/**
 * Returns a deep copy of the object
 */
export function deepCopy(oldObj: any) {
  var newObj = oldObj;
  if (oldObj && typeof oldObj === "object") {
    if (oldObj instanceof Date) {
      return new Date(oldObj.getTime());
    }
    newObj = Object.prototype.toString.call(oldObj) === "[object Array]" ? [] : {};
    for (var i in oldObj) {
      newObj[i] = deepCopy(oldObj[i]);
    }
  }
  return newObj;
}

export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export function stringifyList(items: any[], ...by: string[]) {
  if (!items || items.length === 0) {
    return undefined;
  }

  return items.map(item => {
    for (const field of by) {
      if (item[field]) {
        return `${item[field]}`;
      }
    }
    return 'N/A';
  }).sort().join(', ');
}

let bodyLockCount = 0;
let previousBodyOverflow: string | null = null;

/**
 * Locks body scrolling by setting overflow to hidden.
 * Uses a reference counter to handle multiple simultaneous popovers/modals.
 * Useful for popovers, modals, and overlays to prevent background scrolling.
 */
export function lockBodyScroll() {
  if (bodyLockCount === 0) {
    previousBodyOverflow = document.body.style.overflow || '';
    document.body.style.overflow = 'hidden';
  }
  bodyLockCount += 1;
}

/**
 * Restores body scrolling by removing the overflow style.
 * Uses a reference counter to only restore when all popovers/modals are closed.
 * Should be called when closing popovers, modals, or overlays.
 */
export function unlockBodyScroll() {
  bodyLockCount = Math.max(0, bodyLockCount - 1);
  if (bodyLockCount === 0 && previousBodyOverflow !== null) {
    document.body.style.overflow = previousBodyOverflow;
    previousBodyOverflow = null;
  }
}
